import {
  createStyles,
  Dialog,
  DialogActions,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { t } from 'ttag';
import { useStoreState } from '@models/RootStore';
import { Button, IconButton } from '@coolremote/shared';

const useStyles = makeStyles((theme) =>
  createStyles({
    dialogPaper: {
      width: '640px',
      maxWidth: 'calc(100vw - 48px)',
      maxHeight: 'calc(100vh - 48px)',
      display: 'flex',
      flexDirection: 'column',
    },
    dialogHeader: {
      paddingLeft: 20,
      paddingRight: 13,
      ...theme.dialogs.header,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 60,
      minHeight: 60,
    },
    dialogContent: {
      flex: '1 1 auto',
      padding: 20,
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
    },
    iconBtnStyle: {
      width: 30,
      height: 30,
      borderRadius: 6,
      padding: 0,
    },
    headerTitle: {
      ...theme.dialogs.title,
    },
  })
);

const EditMonnitDevice = (props) => {
  const { isOpen, close, device, updateMonnitDeviceSamplingRate } = props;
  const classes = useStyles();
  const {
    type: deviceBrand = 0,
    deviceType = 1,
    serial,
    monnitAccountId,
    monnitApiKey,
    monnitSamplingRateMinutes,
  } = device || {};
  const getDevicesTypesNames = useStoreState(
    (state) => state.getDevicesTypesNames
  );
  const deviceTypeName = getDevicesTypesNames(deviceType, deviceBrand);
  const [samplingRateMinutes, setSamplingRateMinutes] = useState(0);
  const parsedSamplingRate = parseInt(samplingRateMinutes, 10);
  const isSamplingRateValid =
    samplingRateMinutes !== '' &&
    Number.isInteger(parsedSamplingRate) &&
    parsedSamplingRate >= 1 &&
    parsedSamplingRate <= 60;

  useEffect(() => {
    setSamplingRateMinutes(monnitSamplingRateMinutes);
  }, [device]);

  const handleSamplingRateChange = (event) => {
    setSamplingRateMinutes(event.target.value);
  };

  const getSamplingRateHelperText = () => {
    if (isSamplingRateValid) {
      return '';
    }

    return t`Value must be between 1 and 60`;
  };

  const handleSave = () => {
    if (!isSamplingRateValid) {
      return;
    }

    updateMonnitDeviceSamplingRate(device.id, parsedSamplingRate);
    close(null);
  };

  return (
    <Dialog
      open={!!device && isOpen}
      onClose={() => close(null)}
      aria-labelledby="mapping-dialog-title"
      aria-describedby="mapping-dialog-description"
      fullWidth
      maxWidth="sm"
      PaperProps={{
        className: classes.dialogPaper,
      }}
    >
      <div className={classes.dialogHeader}>
        <Typography className={classes.headerTitle}>
          {t`Device settings:`} {deviceTypeName} {serial}
        </Typography>
        <IconButton
          onClick={() => close(null)}
          className={classes.iconBtnStyle}
        >
          <Close />
        </IconButton>
      </div>
      <div className={classes.dialogContent}>
        <Grid container spacing={2}>
          <Grid item xs={12} container spacing={2} alignItems="center">
            <Grid item xs={3}>
              <Typography>{t`Account ID`}</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                id="monnitAccountId"
                fullWidth
                value={monnitAccountId}
                InputProps={{ readOnly: true }}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} container spacing={2} alignItems="center">
            <Grid item xs={3}>
              <Typography>{t`API key`}</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                id="monnitApiKey"
                fullWidth
                value={monnitApiKey}
                InputProps={{ readOnly: true }}
                disabled={true}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} container spacing={2} alignItems="center">
            <Grid item xs={3}>
              <Typography>{t`Sampling Rate`}</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                id="monnitSamplingRateMinutes"
                fullWidth
                type="number"
                value={samplingRateMinutes}
                onChange={handleSamplingRateChange}
                error={!isSamplingRateValid}
                helperText={getSamplingRateHelperText()}
                InputProps={{ inputProps: { min: 1, max: 60 } }}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>

      <DialogActions
        className={classes.dialogActionStyle}
        classes={{ spacing: classes.actionsSpacing }}
      >
        <Button width={100} white marginRight onClick={() => close(null)}>
          {t`Cancel`}
        </Button>

        <Button
          width={100}
          onClick={handleSave}
          disabled={!isSamplingRateValid}
        >
          {t`Submit`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditMonnitDevice;
